var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 660,
    height: 748,
    viewBox: "0 0 660 748",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.023 650.89H108.276L108.276 97.3619L295.622 97.3619V0.664062L0.608398 0.664062L0.608398 747.621H295.023V650.89Z",
    fill: "#f92b18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.99 170.99H180.642L180.642 582.779H294.99V170.99Z",
    fill: "#f92b18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.397 0.664062V97.3619L551.743 97.3619V650.89H365.029V747.621H659.411V0.664062L364.397 0.664062Z",
    fill: "#f92b18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.377 170.991H365.028V582.78H479.377V170.991Z",
    fill: "#f92b18"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 658.802,
    height: 746.957,
    fill: "white",
    transform: "translate(0.608398 0.664062)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegral);
export default __webpack_public_path__ + "static/media/integral.2fee35e79b4e02340fc114c8f2164317.svg";
export { ForwardRef as ReactComponent };